import DarkInfoIcon from '../../images/darkInfoIcon.svg?react';
import { Tooltip } from '@/components/Tooltip/Tooltip';
import { Box } from '@/components/Box/Box';
import { TooltipIconWrapper } from './styles';
import { MouseEvent, ReactNode } from 'react';
import { useResponsiveDevice } from '@/hooks/useResponsiveDevice';

type UtcTooltipType = {
  message: ReactNode;
};

export const UtcTooltip = ({ message }: UtcTooltipType) => {
  const { isMobile } = useResponsiveDevice();

  // Stop propagating click event when tooltip inside "clickable" parent
  const tooltipIconClick = (event: MouseEvent<HTMLDivElement>) => {
    if (!isMobile) return;

    event.stopPropagation();
  };

  return (
    <Box marginRight='6px'>
      <Tooltip id='utc-tooltip' offset={2}>
        {message}
      </Tooltip>
      <TooltipIconWrapper onClick={tooltipIconClick}>
        <DarkInfoIcon data-tooltip-id='utc-tooltip' />
      </TooltipIconWrapper>
    </Box>
  );
};
